import { gql } from "@apollo/client";

export const NotificationSettings = gql`
    query NotificationSettings {
        notificationSettings {
            id
            subscriber {
                id
                applicationId
                hmacHash
            }
            general {
                push
                inApp
                email
            }
            schedule {
                isEnabled
                monday    { isEnabled from to }
                tuesday   { isEnabled from to }
                wednesday { isEnabled from to }
                thursday  { isEnabled from to }
                friday    { isEnabled from to }
                saturday  { isEnabled from to }
                sunday    { isEnabled from to }
            }
        }
    }
`;
